<script setup lang="ts">
defineProps<{
  showListView: boolean
  chartCount: number
  sortOrder: string
  sortOrderOptions: { value: string; title: string }[]
  phaseFilterOptions: { value: string; title: string }[]
  isPhaseActive: (value: string) => boolean
}>()

const emit = defineEmits<{
  backToList: []
  createChart: []
  backToProject: []
  viewInput: []
  editSourceRows: []
  resetCalculation: []
  exportChart: []
  setSortOrder: [value: string]
  togglePhase: [value: string]
}>()
</script>

<template>
  <v-row align="center" justify="space-between">
    <v-col cols="12" md="3" class="d-flex align-center flex-wrap gap-2">
      <v-btn
        v-if="!showListView && chartCount > 1"
        variant="text"
        color="cyan-darken-2"
        prepend-icon="mdi-view-grid"
        @click="emit('backToList')"
      >
        All charts
      </v-btn>

      <v-btn
        v-if="!showListView"
        variant="text"
        color="cyan-darken-2"
        prepend-icon="mdi-plus"
        @click="emit('createChart')"
      >
        Add another chart
      </v-btn>
    </v-col>

    <v-col cols="12" md="9" class="toolbar-right">
      <v-btn
        variant="flat"
        color="cyan-lighten-4"
        prepend-icon="mdi-arrow-left"
        @click="emit('backToProject')"
      >
        Back to project
      </v-btn>

      <v-btn variant="outlined" @click="emit('viewInput')"> View input </v-btn>
      <v-btn variant="outlined" @click="emit('editSourceRows')">Modify Label</v-btn>
      <v-btn variant="outlined" @click="emit('resetCalculation')"> Reset calculation </v-btn>

      <v-btn
        v-if="!showListView"
        variant="text"
        append-icon="mdi-menu-down"
        class="toolbar-select export-toolbar-button"
        @click="emit('exportChart')"
      >
        Choose files for download
      </v-btn>

      <v-menu location="bottom end">
        <template v-slot:activator="{ props }">
          <v-btn v-bind="props" variant="text" append-icon="mdi-menu-down" class="toolbar-select">
            Sort your results
          </v-btn>
        </template>
        <v-list density="compact" min-width="200">
          <v-list-item
            v-for="option in sortOrderOptions"
            :key="option.value"
            :active="sortOrder === option.value"
            @click="emit('setSortOrder', option.value)"
          >
            <v-list-item-title>{{ option.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu :close-on-content-click="false" location="bottom end">
        <template v-slot:activator="{ props }">
          <v-btn
            v-bind="props"
            variant="text"
            append-icon="mdi-filter-variant"
            class="toolbar-select"
          >
            Select your filters
          </v-btn>
        </template>
        <v-card min-width="240" class="pa-2">
          <div class="text-caption text-medium-emphasis px-2 pb-1">Lifecycle phases</div>
          <v-checkbox
            v-for="option in phaseFilterOptions"
            :key="option.value"
            :label="option.title"
            :model-value="isPhaseActive(option.value)"
            @update:model-value="emit('togglePhase', option.value)"
            density="compact"
            hide-details
            class="my-0"
          />
        </v-card>
      </v-menu>
    </v-col>
  </v-row>
</template>

<style scoped>
.toolbar-right {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}

.toolbar-select {
  text-transform: none;
}

.export-toolbar-button {
  background-color: #e5f7fa;
  border-radius: 999px;
  color: #1697a7;
  font-weight: 600;
  padding: 0 18px;
}
</style>
